import React, { useEffect, useState } from "react";
import { Divider, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { SubscriptionsActionHandler } from "../../../../Redux/Actions/user/Subscriptions";
import { SubscriptionsCancleActionHandler } from "../../../../Redux/Actions/user/SubscriptionsCancle";
import { format } from "date-fns";
import "../Billing.css";
import Loader from "../../../../Components/Loader/Loader";

const Overview = () => {
  let dispatch = useDispatch();
  const [isCloseButtonVisible, setCloseButtonVisibility] = useState({});
  const subscriptionsData = useSelector(
    (state) => state?.SubscriptionsData?.subscriptions_data?.data
  );
  const subscriptionsCancleData = useSelector(
    (state) => state?.SubscriptionsCancleData?.subscriptions_cancle_data?.data
  );
  const fetchData = async () => {
    try {
      dispatch(SubscriptionsActionHandler());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleFirstCardButtonClick = (itemId, flage) => {
    setCloseButtonVisibility((prevToggleState) => ({
      ...prevToggleState,
      ["itemId"]: itemId,
      ["flage"]: flage,
    }));
  };

  const handleCloseButtonClick = (itemId, flage) => {
    setCloseButtonVisibility((prevToggleState) => ({
      ...prevToggleState,
      ["itemId"]: itemId,
      ["flage"]: flage,
    }));
  };

  const handleCancleButtonClick = (id) => {
    dispatch(SubscriptionsCancleActionHandler(id));
  };

  const userSlugData = useSelector(
    (state) => state.SettingsUserProfileData.slug
  );

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="over-main">
      <div className="over-cards">
        {subscriptionsData ? (
          subscriptionsData &&
          subscriptionsData.map((subscriptions, index) => (
            <div className="starter1 position-relative">
              <div className="button-line">
                <button className="starter-btn">
                  {subscriptions.subscription_name}
                </button>
                {userSlugData?.includes("cancel-subscription") && (
                  <p
                    onClick={() =>
                      handleFirstCardButtonClick(subscriptions.id, true)
                    }
                  >
                    ...
                  </p>
                )}
                {isCloseButtonVisible.flage ? (
                  <>
                    {isCloseButtonVisible.itemId === subscriptions.id && (
                      <div className="over">
                        <div className="d-flex justify-content-end px-3">
                          <Button
                            className="close-btn"
                            type="text"
                            placement="right"
                            shape="circle"
                            icon={<CloseOutlined />}
                            size="large"
                            onClick={() =>
                              handleCloseButtonClick(subscriptions.id, false)
                            }
                          />
                        </div>
                        <div className="cross-menu">
                          <img
                            className="tri-img"
                            src="/images/tri.svg"
                            alt=""
                          />
                          <div className="menu-content">
                            <p className="content">
                              This plan is cancelled. Pay now to start a new
                              subscription.
                            </p>
                            <div className="pay-btn">
                              <button
                                onClick={() =>
                                  handleCancleButtonClick(
                                    subscriptions.subscription_item_id
                                  )
                                }
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : null}
              </div>
              <div className="amount-div">
                <p className="amount font-32bold">
                  £{subscriptions?.price?.toLocaleString()} <span>/month</span>
                </p>
              </div>
              <Divider />
              <div className="divi-down">
                <div className="date-sec">
                  <p className="date-label">Start date</p>
                  <p className="actual-date">
                    {format(new Date(subscriptions.start_date), "M/dd/yyyy")}
                  </p>
                </div>
                <div className="workspace-div">
                  <p className="workspace-label">Workspace</p>
                  <p className="workspace">{subscriptions.name}</p>
                </div>
                <div className="credits-div">
                  <p className="credits-label">Credits</p>
                  <p className="actual-credits">
                    Used:{" "}
                    <span className="workspace-text">
                      {subscriptions.num_tokens} |
                    </span>{" "}
                    remaining:{" "}
                    <span className="workspace-text">
                      {subscriptions.remaining_tokens}
                    </span>
                  </p>
                </div>
                <div className="purchased-div">
                  <p className="purchased-label">Purchased by</p>
                  <p className="purchasable workspace-text">
                    {subscriptions.purchased_by}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};
export default Overview;
